import api from "./axios";

const BASE = "/leaves";

export const listPendingLeaves = async (params = {}) => {
  return api.get(`${BASE}/pending`, { params });
};

export const listApprovedLeaves = async (params = {}) => {
  return api.get(`${BASE}/approved`, { params });
};

export const listRejectedLeaves = async (params = {}) => {
  return api.get(`${BASE}/rejected`, { params });
};

export const approveLeave = async (id) => {
  return api.put(`${BASE}/${id}/approve`);
};

export const rejectLeave = async (id, rejectionReason) => {
  return api.put(`${BASE}/${id}/reject`, { rejectionReason });
};

export const bulkApproveLeaves = async (ids) => {
  return api.post(`${BASE}/bulk-approve`, { ids });
};

export const deleteLeave = async (id, reason) => {
  return api.delete(`${BASE}/${id}`, { data: { reason } });
};

export const exportLeaves = async (params = {}) => {
  return api.get(`${BASE}/export`, {
    params,
    responseType: "blob",
  });
};

export const downloadLeaveAttachment = async (id) => {
  return api.get(`${BASE}/${id}/attachment`, {
    responseType: "blob",
  });
};
